import type { FC, ReactNode } from 'react';

import { memo, useMemo, useCallback } from 'react';
import isEqual from 'react-fast-compare';

import { S } from './styles';
import { useCarouselContext } from '~/components/shared/core/carousel/CarouselContext';
import type { RovingFocusItemProps } from '~/utilities/hooks/useRovingFocus';

interface CarouselScrollItemProps {
  index: number;
  children: (props: RovingFocusItemProps & { setTileWidth: (width: number) => void }) => ReactNode;
}

const CarouselScrollItemComponent: FC<CarouselScrollItemProps> = ({ children, index }) => {
  const { setTileWidth, getItemProps } = useCarouselContext();

  const itemProps = useMemo(() => getItemProps(index) ?? {}, [getItemProps, index]);

  const handleRef = useCallback(
    (e: HTMLLIElement) => {
      if (e) {
        setTileWidth(Math.ceil(e.getBoundingClientRect().width));
      }
    },
    [setTileWidth]
  );

  const combinedProps = useMemo(
    () => ({
      ...itemProps,
      setTileWidth,
    }),
    [itemProps, setTileWidth]
  );

  return <S.TileWrapper ref={handleRef}>{children(combinedProps)}</S.TileWrapper>;
};

export const CarouselScrollItem = memo(CarouselScrollItemComponent, isEqual);
